import { useRef, useState } from "react"
import QuizSection from "./QuizSection"
import KeyTakeAway from "./KeyTakeAway"
import ToggleButton from "./components/ToggleButton"
import ChatSection from "./ChatSection"
import PersonalisedForYou from "./PersonalisedForYou"
import LearnTubeXIllustartion from "./components/LearnTubeXIllustartion"
import { useSelector } from "react-redux"
import { selectSubscriptionStatus } from "../../redux/personaliseLessons/subscriptionStatusSlice"
import { selectBottomIllustationStatus } from "../../redux/personaliseLessons/bottomIllustration"
import { selectAuthentication } from "../../redux/personaliseLessons/authenticationSlice"
import { selectCourseList } from "../../redux/personaliseLessons/courseListSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamation } from "@fortawesome/free-solid-svg-icons"


const DesktopOtherSection = ({ lessonName, userGoal, setUserGoal, course_slug, lesson_slug, module_slug, lessonDetails, moduleName, isToggled, setIsToggled, quizRef }) => {

    const subscriptionStatus = useSelector(selectSubscriptionStatus)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const authentication = useSelector(selectAuthentication)
    const subject_name = useSelector(selectCourseList)?.courseName

    const [ showKeyPoints, setShowKeyPoints ] = useState(false)
    const [ showQuiz, setShowQuiz ] = useState(true)
    const [ showAskCreator, setShowAskCreator ] = useState(false)
    const [isAtEnd, setIsAtEnd] = useState(false);

    const sentinelRef1 = useRef(null)
    
    const handleToggle = (index) => {
        if (index === 0){
            setShowQuiz(true)
            setShowAskCreator(false)
            setShowKeyPoints(false)
        }else if (index === 1){
            setShowQuiz(false)
            setShowAskCreator(false)
            setShowKeyPoints(true)
        }else if (index === 2){
            setShowQuiz(false)
            setShowAskCreator(true)
            setShowKeyPoints(false)
        }
    }

    return (
        <div className='w-full flex flex-col lg:mt-5 lg:px-6 pb-4 lg:pb-6'>
            <h3 className="text-2xl max-lg:hidden font-medium">{lessonName}</h3>
            <div className="flex max-lg:text-center max-lg:justify-between gap-3 border-b border-[#196BBD] mt-4 overflow-x-scroll max-lg:px-2">
                <div className={`lg:w-[175px] max-lg:flex-1 text-xl max-lg:text-sm cursor-pointer reactour-desktop-quizsection reactour-quizsection flex justify-center items-center leading-5 ${showQuiz ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#4F6E8D]'} pb-3`} onClick={() => handleToggle(0)}>
                    <h3>Quiz</h3>
                    {(lessonDetails?.lesson_status !== 'completed') && <div className="w-5 h-5 ml-2 rounded-full border-2 border-[#F59E0B] flex items-center justify-center "><FontAwesomeIcon icon={faExclamation} className="text-sm text-[#F59E0B]" /></div>}
                </div>
                <div className={`lg:w-[175px] max-lg:flex-1 text-xl max-lg:text-sm cursor-pointer flex reactour-desktop-keypoints reactour-keypoints justify-center items-center leading-5 ${showKeyPoints ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#4F6E8D]'} pb-3`} onClick={() => handleToggle(1)}>
                    <h3>Key Takeways</h3>
                </div>
                <div className={`lg:w-[175px] max-lg:flex-1 text-xl max-lg:text-sm cursor-pointer reactour-desktop-chatsection reactour-chatsection flex justify-center items-center leading-4 ${showAskCreator ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#4F6E8D]'} pb-3`} onClick={() => handleToggle(2)}>
                    <h3>Ask The Creator</h3>
                </div>
            </div>
            <div ref={quizRef}>
                {showQuiz && <QuizSection
                    userGoal={userGoal}
                    setUserGoal={setUserGoal}
                    course_slug={course_slug}
                    lesson_slug={lesson_slug}
                    module_slug={module_slug}
                    moduleName={moduleName}
                />}
                {showKeyPoints && <div className="mt-5 rounded-xl relative reactour-keypoints px-4">
                    <div className='hidden justify-between items-center'>
                        <h2 className='text-2xl font-semibold'>Key Takeaways</h2>
                        <PersonalisedForYou/>
                    </div>
                    <div className="bg-[#2D4F71] rounded-lg mt-3">
                        <KeyTakeAway
                            course_slug={course_slug}
                            userGoal={userGoal}
                            setUserGoal={setUserGoal}
                            lesson_slug={lesson_slug}
                        />
                    </div>
                </div>}
                {showAskCreator && <>
                    <div className='flex items-center justify-between px-4 mt-5 mb-3'>
                        <h2 className='text-2xl font-semibold flex-1'>Ask The Creator</h2>
                        <div className='flex items-center justify-between mt-1'>
                            <div className='w-[15px] h-[16.7px] mr-2'>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/Vector.png?updatedAt=1689172663353" alt="" className='w-full h-full'/>
                            </div>
                            <p className='text-sm mr-2'>Audio</p>
                            <ToggleButton
                                isToggled={isToggled}
                                setIsToggled={setIsToggled}
                            />
                        </div>
                    </div>
                    <div className="px-4">
                        <ChatSection
                            lesson_id={lessonDetails?.lesson_id}
                            course_slug={course_slug}
                            video_id={lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]}
                            isToggled={isToggled}
                            lessonDetails={lessonDetails}
                        />
                    </div>
                </>}
            </div>
            {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='p-4 lg:hidden'>
                <LearnTubeXIllustartion
                    sentinelRef={sentinelRef1}
                    isAtEnd={isAtEnd}
                    setIsAtEnd={setIsAtEnd}
                    course_slug={subject_name}
                    authentication={authentication}
                />
            </div> : <div className='w-full h-4'></div>}
        </div>
    )
}

export default DesktopOtherSection